import { NgModule } from "@angular/core";
import {
  AvatarModule,
  BadgeModule,
  BreadcrumbModule,
  ButtonGroupModule,
  ButtonModule,
  CardModule,
  DropdownModule,
  FooterModule,
  FormModule,
  GridModule,
  HeaderModule,
  ListGroupModule,
  NavModule,
  ProgressModule,
  SharedModule,
  SidebarModule,
  TabsModule,
  TooltipModule,
  UtilitiesModule,
  PaginationModule,
  SpinnerModule,
} from "@coreui/angular";
import { IconModule } from "@coreui/icons-angular";

@NgModule({
  exports: [
    AvatarModule,
    BadgeModule,
    BreadcrumbModule,
    ButtonGroupModule,
    ButtonModule,
    CardModule,
    DropdownModule,
    FooterModule,
    FormModule,
    GridModule,
    HeaderModule,
    ListGroupModule,
    NavModule,
    ProgressModule,
    SharedModule,
    SidebarModule,
    TabsModule,
    TooltipModule,
    UtilitiesModule,
    PaginationModule,
    SpinnerModule,
    IconModule,
  ],
})
export class CoreUIAngularModule {}
